var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpandArrow = function SvgExpandArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62432 9.72849L15.7444 2.15369C15.9092 1.97849 16 1.74462 16 1.49525C16 1.24588 15.9092 1.01201 15.7444 0.836816L15.2202 0.278985C14.8786 -0.0839998 14.3234 -0.0839998 13.9823 0.278985L8.00332 6.63973L2.01768 0.271927C1.85286 0.0967307 1.63316 -6.27995e-07 1.39888 -6.38235e-07C1.16435 -6.48487e-07 0.944643 0.0967307 0.779701 0.271926L0.255608 0.829758C0.0907964 1.00509 8.99524e-07 1.23882 8.88623e-07 1.48819C8.77723e-07 1.73757 0.0907964 1.97144 0.255608 2.14663L7.38218 9.72849C7.54752 9.9041 7.76826 10.0006 8.00293 10C8.2385 10.0006 8.45912 9.9041 8.62432 9.72849Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpandArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "expand-arrow.d186470f189cbe54769ff59008ee0668.svg";